class ProColours extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const dialog = this.querySelector('dialog');
    const trigger = this.querySelector('[data-colours-open]');
    if (!dialog || !trigger) return;
    trigger.addEventListener('click', () => dialog.showModal(), options);
    this.querySelector('[data-colours-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }, options);
    dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus({ preventScroll: true }); }, options);
    const tabs = [...this.querySelectorAll('[data-colours-tab]')];
    const select = (index) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.querySelectorAll('[data-colours-panel]').forEach((panel, i) => { panel.hidden = i !== index; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index), options);
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(next); tabs[next].focus();
      }, options);
    });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('rxk-pro-colours')) customElements.define('rxk-pro-colours', ProColours);
